import {SlugHelper} from "./slug.helper";

/**
 * The route path of a whiteboard or document: `/knowledge/<uid>/<slug>`, or `/knowledge/<uid>`
 * when the title slugs to nothing. The uid is used as it is — a ShortId is Base64URL and
 * case-sensitive, so changing its case would address a different object.
 *
 * Kept free of other imports on purpose: tests import it directly, and pulling in `ui.helper`
 * here would register `@o2d/popover-list` in every one of them.
 */
export function buildKnowledgeObjectPath(uid: string, title: string): string {
    const slug = SlugHelper.toKebabCase(title);

    return slug ? `/knowledge/${uid}/${slug}` : `/knowledge/${uid}`;
}
